import React, { useState } from 'react';

import { sitemap } from 'app/shared/util/url-utils';
import { useNavigate } from 'react-router-dom';
import { AccountSectionPresentation } from './AccountSection';
import { useSwitchAccount } from 'app/shared/hooks/account/useSwitchAccount';
import { CreateOrganizationDialog } from 'app/shared/components/account/CreateOrganizationDialog';

interface AccountSectionProps {
  email: any;
  accountOptions: any;
  selectedAccount: any;
}

export const AccountSection = ({ accountOptions, selectedAccount }: AccountSectionProps) => {
  const navigate = useNavigate();
  const { switchTo } = useSwitchAccount();
  const [orgDialogOpen, setOrgDialogOpen] = useState(false);

  const handleChange = async (_event, newAccount) => {
    _event.preventDefault();
    if (!newAccount) return;

    if (newAccount.id === '-1') {
      setOrgDialogOpen(true);
      return;
    }
    if (newAccount.id === selectedAccount?.id) return;

    await switchTo(newAccount.id);
    navigate(sitemap.home);
  };

  return (
    <>
      <AccountSectionPresentation
        accountOptions={accountOptions}
        selectedAccount={selectedAccount}
        handleChange={handleChange}
      />
      <CreateOrganizationDialog open={orgDialogOpen} onClose={() => setOrgDialogOpen(false)} />
    </>
  );
};
